<template>
  <div class="pendingDetails">
    <topTitle title="订单详情" :options="iswc?{'bgColor':'linear-gradient(to right, #fe8347, #fe7946, #ff4343)','navColor':'#fff'}:{'bgColor': '','navColor':'#000000'}"></topTitle>
    <div class="pendingtop" v-if="!iswc">
      <div>
        <img src="../../assets/localImage/payment.png" alt />
      </div>
      <h2>
        <template v-if="!isfh">
          <p>等待卖家发货</p>
        </template>
        <template v-else>
          <p>卖家已发货</p>
          <p class="min">
            物流单号:{{details.ship_no}}
            <img  @click="copy(details.ship_no)" src="../../assets/localImage/fz.png" alt  />
          </p>
        </template>
      </h2>
    </div>

    <div class="finishtop" v-else>
      <div class="top">
        <div>
          <img src="../../assets/localImage/successfulPayment.png" alt="">
        </div>
        <p>订单已完成！</p>
      </div>
      <div class="btn">
        <div @click="qpj(details.sn , 1)">去评价</div>
        <div @click="qpj(details.sn , 2)">申请退货</div>
      </div>
    </div>

    <div class="way" v-if="isfh&&!iswc" @click="towlxq()">
      <div class="dd">
        <img src="../../assets/localImage/received.png" alt />
      </div>
      <div class="xx">
        <h2>{{wldetails.context}}</h2>
        <p>{{wldetails.time}}</p>
      </div>
      <div class="jr">
        <img src="../../assets/localImage/path.png" alt />
      </div>
    </div>
    <addressReceiving :addressData="details"></addressReceiving>
    <div class="purchase">
      <div class="shopName">
        <p>
          订单号：{{details.sn}}
          <!-- <span class="r">交易成功</span> -->
        </p>
      </div>
      <div class="od_cont" v-for="(item,index) in details.order_sku_list" :key="index">
        <div class="od_cont_img" @click="qxq(item)" >
          <img :src="item.goods_image" alt />
        </div>
        <div class="od_cont_xinxi" @click="qxq(item)" >
          <h4 class="od_cont_name">
            <div class="l">{{item.name}}</div>
            <!-- <span class="r color-yellow">￥760/桶</span> -->
            <div class="r">
              <p>¥{{item.original_price}}</p>
              <p class="color-999">重消币:¥{{item.point==null?'0':item.point}}</p>
            </div>
          </h4>
          <h4 class="od_cont_font">
            <p>数量：x{{item.num}}</p>
          </h4>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="item">
        <div>配送方式</div>
        <div>{{details.logi_name}}</div>
      </div>
      <div class="item">
        <div>发票</div>
        <div>
          普通
          <span class="color-js">电子</span> 发票（个人）
        </div>
      </div>
      <div class="item">
        <div>运费</div>
        <div>¥{{details.shipping_price}}</div>
      </div>
      <div class="item">
        <div>付款方式</div>
        <div>{{details.payment_method_name == 'weixinPayPlugin'?'微信支付':'支付宝支付'}}</div>
      </div>
      <div class="item">
        <div>重消币</div>
        <div class="color-js">¥{{details.use_point==null?'0':details.use_point}}</div>
      </div>
      <div class="item">
        <div>实付款</div>
        <div class="color-js">¥{{details.order_price}}</div>
      </div>
      <div class="item" v-if="isfh">
        <div>物流单号：</div>
        <div>{{details.ship_no}} <img src="../../assets/localImage/fz2.png" class="zf" alt  @click="copy(details.ship_no)"/></div>
      </div>
    </div>
    <!--  v-if="details.order_status = 'PAID_OFF'" -->
    <div class="shenqingtuikuan" v-if="details.order_status == 'PAID_OFF'" @click="qpj(details.sn , 2)">
       申请退款
    </div>
    <div class="foot" v-if="isfh&&!iswc">
      <button @click="qrsh()">确认收货</button>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import addressReceiving from "../../components/addressReceiving.vue";

import { Dialog , Toast} from "vant";
export default {
  name: "pendingDetails",
  data() {
    return {
      isfh: JSON.parse(this.$route.query.isfh),//是否发货
      iswc: JSON.parse(this.$route.query.iswc),//是否完成
      sn: this.$route.query.sn,
      details:{},
      wldetails:{},
    };
  },
  components: {
    topTitle,
    addressReceiving
  },
  created(){
    this.getDetails();
    console.log(this.isfh,this.iswc)
  },
  methods: {
    //商品详情
    qxq(obj) {
      this.$router.push({path:'./goodsDetail',query:{	goods_id : obj.goods_id}}) 
    },
    qrsh(){
      this.postRequest( `trade/orders/${this.sn}/rog`).then(res => {
        console.log(res.data.data)
        this.iswc = true;
        Toast.success('收货成功');
      })
    },


    copy(text) {
      var input = document.createElement('input');
      input.setAttribute('readonly', 'readonly'); // 防止手机上弹出软键盘
      input.setAttribute('value', text);
      document.body.appendChild(input);
      // input.setSelectionRange(0, 9999);
      input.select();
      var res = document.execCommand('copy');
      document.body.removeChild(input);
      Toast.success('复制成功');
      return res;
    },
    //物流详情
    towlxq(){
      this.$router.push({path:'logisticsInfo', query:{id:this.details.logi_id,num:this.details.ship_no}});
    },
    //去评价页面  1 评价  2 退货
    qpj(sn,type){
       this.$router.push({path:'evaluateOrservice', query:{sn:sn,type:type}});
    },
    //
    getDetails(){
      this.getRequest( `trade/orders/${this.sn}`).then(res => {
        console.log(res.data.data)
        this.details =  res.data.data;
        if(this.isfh){
          this.getRequest( `trade`,{id:res.data.data.logi_id,num:res.data.data.ship_no}).then(res => {
            console.log(res.data.data)
            this.wldetails =  res.data.data.data[0];
          })
        }
        
      })
    }
  }
};
</script>


<style scoped lang='less'>
.pendingDetails {
  .finishtop{
    width: 100%;
    height: 480px;
    background: linear-gradient(to bottom right, #fe8847,#fe4844, #d4180b);
    display: flex;
    flex-direction: column;
    padding-top: 80px;
    .top{
      display: flex;
      align-items: flex-end;
      justify-content: center;
      >div{
        width: 174px;
        height: 140px;
        margin-right: 25px;
      }
      p{
        font-size:30px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1); 
        margin-bottom: 25px;
      }
    }
    .btn{
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 80px;
      padding: 0 50px;
      div{
        width:258px;
        height:70px;
        line-height: 70px;
        text-align: center;
        border-radius:44px;
        background: #fff;
        border:1px solid #fff;
        font-size:32px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,68,68,1);
      }
      div:last-child{
        background: linear-gradient(to right, #f03633, #de2317);
        color: #fff;border:1px solid rgba(255,255,255,1);
      }
    }
  }
  .pendingtop {
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    h2 {
      p {
        font-size: 32px;
        display: flex;
        align-items: center;
        img {
          width: 34px;
          height: 34px;
          margin-left: 10px;
        }
      }
      .min {
        font-size: 26px;
        margin-top: 10px;
      }
    }
    font-family: AlibabaPuHuiTiM;
    background: linear-gradient(to right, #ff9345, #fd5d46, #fd4843);
    > div {
      width: 101px;
      height: 101px;
      margin-right: 27px;
    }
  }
  .way {
    width: 100%;
    // height: 180px;
    background-color: #ffffff;
    display: flex;
    padding: 22px 32px;
    justify-content: space-around;
    align-items: center;
    position: relative;
    border-bottom: 1px solid #f5f5f5;
    .dd {
      width: 47px;
      height: 38px;
    }
    .jr {
      width: 12px;
      height: 22px;
    }
    .xx {
      width: 560px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h2 {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        span {
          margin-left: 50px;
        }
      }
      p {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(119, 119, 119, 1);
      }
    }
  }

  .purchase {
    width: 100%;
    margin: 0 auto;
    background-color: white;
    margin-top: 20px;
    overflow: hidden;
    border-radius: 8px;
    .shopName {
      color: #333333;
      font-size: 26px;
      padding: 24px;
      .r {
        color: #ff1919;
        font-size: 26px;
      }
    }
    .od_cont {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 24px;
      padding-bottom: 45px;
      overflow: hidden;
      .od_cont_img {
        width: 180px;
        height: 180px;
        overflow: hidden;
        float: left;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .od_cont_xinxi {
        width: 460px;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        float: right;
        overflow: hidden;
        > h4 {
          line-height: 53px;
        }
        .od_cont_name {
          color: #333333;
          // line-height: 30px;
          .l {
            width: 280px;
            height: 90px;
            font-size: 26px;
            line-height: 44px;
            float: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .r {
            float: right;
            p {
              text-align: right;
              color: #000000;
              font-size: 24px;
            }
            line-height: 40px;
          }
        }

        .od_cont_font {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
          color: rgba(153, 153, 153, 1);
          .color-js {
            font-size: 24px;
          }
        }
      }
    }
  }
  .list {
    background: #ffffff;
    margin-top: 20px;
    .item {
      width: 100%;
      height: 96px;
      padding: 0 33px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;
      .zf{
        width: 34px;
        height: 34px;
        margin-left: 10px;
        float: right;
        margin-top: 5px;
      }
      .wx {
        img {
          width: 42px;
          height: 37px;
          margin-right: 15px;
          float: left;
        }
      }
      .zfb {
        img {
          width: 38px;
          height: 38px;
          margin-right: 15px;
          float: left;
        }
      }

      /deep/.van-radio__icon--checked .van-icon{
          background: linear-gradient(to right, #fc4d1d, #cf1104);
          border-color: transparent; 
      }
      div {
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        .color-js {
          color: #ff1919;
        }
      }
      .color-js {
        color: #ff1919;
      }
    }
  }
  .shenqingtuikuan{
    color: #ff1919;
    padding: 20px 0;
    background: #fff;
    text-align: center;
  }

  .foot {
    width: 100%;
    height: 94px;
    background: #fff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 40px;
    margin-top: 20px;
    button {
      width: 217px;
      height: 74px;
      text-align: center;
      line-height: 74px;
      border-radius: 37px;
      border: 1px solid rgba(255, 25, 25, 1);
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 25, 25, 1);
      background: #fff;
    }
  }
}
</style>


